import React from "react";

// Minimal, dependency-free fallback. Uses --nd-* custom properties (defined in
// globalStyle.js) with hard-coded fallbacks so it renders correctly even when
// the styled-components ThemeProvider is unavailable — the error may have
// originated inside Layout, above the theme.
function ErrorFallback() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "16px",
        backgroundColor: "var(--nd-black, #000)",
        color: "var(--nd-text-secondary, #999)",
        fontFamily: "Inter, sans-serif",
        fontSize: "14px",
      }}
    >
      <span style={{ color: "var(--nd-text-display, #fff)", fontSize: "18px" }}>
        Something broke
      </span>
      <a
        href={typeof window !== "undefined" ? window.location.pathname : "/"}
        style={{ color: "var(--nd-interactive, #5B9BF6)", textDecoration: "none" }}
      >
        Reload page
      </a>
    </div>
  );
}

// Catches render-time throws in any page tree and shows the fallback instead of
// white-screening the route. Mounted in wrapPageElement (gatsby-browser.js +
// gatsby-ssr.js), so a new instance is created on each client-side navigation —
// a crash on one route auto-resets when navigating to another.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Surfaces to browser console; replace with a real logger (Sentry etc.)
    // when observability is wired.
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return <ErrorFallback />;
    }
    return this.props.children;
  }
}
